<script>
  export let show = false;
  export let allowClose = true;
  export let widthLg = false;
  export let fullScreen = false;
  export let closeFn = null;

  $: toggle(show);

  function toggle(show) {
    if (process.browser) {
      document.body.style.overflowY = show ? 'hidden' : 'auto';
    }
  }

  function closeModal(e) {
    if (allowClose && e.target.closest('#main') == null) {
      if (closeFn) {
        closeFn();
      }
      show = false;
    }
  }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div class="parent" class:show on:click={closeModal}>
  <main id="main" class:width-lg={widthLg} class:full-screen={fullScreen}>
    <slot />
  </main>
</div>

<style>
  .parent {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 50;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(1rem);
    justify-content: center;
    align-items: center;
    display: none;
  }

  .parent.show {
    display: flex;
  }

  main {
    background-color: #fff;
    padding: 2rem;
    border-radius: 0.5rem;
    min-width: 30rem;
    width: 95%;
    margin: 0 auto;
    max-width: 60rem;
    max-height: 60rem;
    overflow-y: auto;
  }

  .width-lg {
    max-width: 120rem;
  }

  .full-screen {
    max-width: 100%;
    max-height: 100%;
    border-radius: 0;
    margin: 0;
  }
</style>
